{
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Por favor, selecione uma conversa no painel da esquerda",
    "CSAT_REPLY_MESSAGE": "Por favor, avalie a conversa",
    "404": "Desculpe, não encontrámos a conversa. Por favor, tente novamente",
    "SWITCH_VIEW_LAYOUT": "Alternar o layout",
    "DASHBOARD_APP_TAB_MESSAGES": "Mensagens",
    "UNVERIFIED_SESSION": "A identidade deste utilizador não foi verificada",
    "NO_MESSAGE_1": "Não há mensagens de clientes na sua caixa de entrada.",
    "NO_MESSAGE_2": " para enviar uma mensagem para a sua página!",
    "NO_INBOX_1": "Ainda não adicionou nenhuma caixa de entrada.",
    "NO_INBOX_2": " para começar",
    "NO_INBOX_AGENT": "Não faz parte de nenhuma caixa de entrada. Por favor, contacte o administrador",
    "SEARCH_MESSAGES": "Procurar mensagens em conversas",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "EMPTY_STATE": {
      "CMD_BAR": "para abrir o menu de comandos",
      "KEYBOARD_SHORTCUTS": "para ver atalhos de teclado"
    },
    "SEARCH": {
      "TITLE": "Procurar mensagens",
      "RESULT_TITLE": "Resultados da pesquisa",
      "LOADING_MESSAGE": "A preparar os dados...",
      "PLACEHOLDER": "Insira qualquer texto para procurar mensagens",
      "NO_MATCHING_RESULTS": "Nenhum resultado encontrado."
    },
    "UNREAD_MESSAGES": "Mensagens por ler",
    "UNREAD_MESSAGE": "Mensagens por ler",
    "CLICK_HERE": "Clique aqui",
    "LOADING_INBOXES": "A carregar caixas de entrada",
    "LOADING_CONVERSATIONS": "A carregar conversas",
    "CANNOT_REPLY": "Não pode responder porque",
    "24_HOURS_WINDOW": "Mensagens bloqueadas durante 24 horas",
    "48_HOURS_WINDOW": "Mensagens bloqueadas durante 48 horas",
    "API_HOURS_WINDOW": "Só pode responder a esta conversa dentro de {hours} horas",
    "NOT_ASSIGNED_TO_YOU": "Esta conversa não está atribuída a si. Gostaria de atribuir esta conversa a si mesmo?",
    "ASSIGN_TO_ME": "Atribuir a mim",
    "BOT_HANDOFF_MESSAGE": "You are responding to a conversation which is currently handled by an assistant or a bot.",
    "BOT_HANDOFF_ACTION": "Mark open and assign to you",
    "BOT_HANDOFF_REOPEN_ACTION": "Mark conversation open",
    "BOT_HANDOFF_SUCCESS": "Conversation has been handed over to you",
    "BOT_HANDOFF_ERROR": "Failed to take over the conversation. Please try again.",
    "TWILIO_WHATSAPP_CAN_REPLY": "Só pode responder utilizando uma mensagem modelo, porque",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "Mensagens bloqueadas durante 24 horas",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "Esta conta do Instagram foi migrada para a nova caixa de entrada do canal Instagram. Todas as novas mensagens aparecerão lá. Já não poderá enviar mensagens a partir desta conversa.",
    "INSTAGRAM_RESTRICTION_BANNER": "Instagram is currently restricted. Some messages or actions may be delayed or unavailable while we restore full support.",
    "INSTAGRAM_RESTRICTION_STATUS_LINK": "View status update",
    "REPLYING_TO": "Está a responder a:",
    "REMOVE_SELECTION": "Remover seleção",
    "DOWNLOAD": "Descarregar",
    "UNKNOWN_FILE_TYPE": "Ficheiro desconhecido",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file",
      "MEETING": "{sender} iniciou uma reunião"
    },
    "UPLOADING_ATTACHMENTS": "A carregar anexos...",
    "REPLIED_TO_STORY": "Respondeu à sua história",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "Esta mensagem não é suportada. Pode ver esta mensagem na app Facebook Messenger.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "Esta mensagem não é suportada. Pode ver esta mensagem na app do Instagram.",
    "UNSUPPORTED_MESSAGE_TIKTOK": "This message is unsupported. You can view this message on the TikTok app.",
    "UNSUPPORTED_MESSAGE_WHATSAPP": "This message is unsupported. You can view this message on the WhatsApp app.",
    "SUCCESS_DELETE_MESSAGE": "Mensagem apagada com sucesso",
    "FAIL_DELETE_MESSSAGE": "Não foi possível apagar a mensagem! Por favor, tente novamente",
    "NO_RESPONSE": "Sem resposta",
    "RESPONSE": "Response",
    "RATING_TITLE": "Avaliar",
    "FEEDBACK_TITLE": "Comentários",
    "REPLY_MESSAGE_NOT_FOUND": "Mensagem indisponível",
    "CARD": {
      "SHOW_LABELS": "Mostrar etiquetas",
      "HIDE_LABELS": "Ocultar etiquetas",
      "LABELS_COUNT": "{count} labels"
    },
    "VOICE_CALL": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NO_ANSWER": "No answer",
      "NO_ANSWER_OUTBOUND_LABEL": "No answer",
      "NO_ANSWER_OUTBOUND_SUBTEXT": "Contact didn't pick up",
      "MISSED_CALL": "Missed call",
      "MISSED_CALL_INBOUND_SUBTEXT": "No agent picked up",
      "MISSED_CALL_DECLINED_BY": "Declined by {agentName}",
      "CALL_ENDED": "Call ended",
      "HANDLED_BY": "Handled by {agentName}",
      "NOT_ANSWERED_YET": "Not answered yet",
      "CALLING": "Calling…",
      "THEY_ANSWERED": "They answered",
      "YOU_ANSWERED": "You answered",
      "AGENT_ANSWERED": "{agentName} answered",
      "JOIN_CALL": "Join call",
      "CALL_BACK": "Call back",
      "TRANSCRIPT_SHOW_MORE": "Show more",
      "TRANSCRIPT_SHOW_LESS": "Show less"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Resolver",
      "REOPEN_ACTION": "Reabrir",
      "OPEN_ACTION": "Abertas",
      "MORE_ACTIONS": "Mais ações",
      "OPEN": "Mais",
      "CLOSE": "Fechar",
      "DETAILS": "Detalhes",
      "COPY_ID_SUCCESS": "Conversation ID copied to clipboard",
      "SNOOZED_UNTIL": "Suspender até",
      "SNOOZED_UNTIL_TOMORROW": "Adiada até amanhã",
      "SNOOZED_UNTIL_NEXT_WEEK": "Adiada até a próxima semana",
      "SNOOZED_UNTIL_NEXT_REPLY": "Adiada até à próxima resposta",
      "WHATSAPP_CALL": "Start WhatsApp call",
      "WHATSAPP_CALL_FAILED": "Could not start the WhatsApp call.",
      "VOICE_CALL": "Start call",
      "VOICE_CALL_FAILED": "Could not start the call.",
      "WHATSAPP_CALL_PERMISSION_REQUESTED": "Sent a call permission request to the contact. Try again once they accept.",
      "WHATSAPP_CALL_PERMISSION_PENDING": "Call permission request already sent recently. Try again once the contact accepts.",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Marcar como pendente",
      "SNOOZE_UNTIL": "Adiar",
      "SNOOZE": {
        "TITLE": "Suspender até",
        "NEXT_REPLY": "Próxima resposta",
        "TOMORROW": "Amanhã",
        "NEXT_WEEK": "Próxima semana"
      }
    },
    "MENTION": {
      "AGENTS": "Agentes",
      "TEAMS": "Equipas"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Suspender até",
      "APPLY": "Adiar",
      "CANCEL": "Cancelar"
    },
    "PRIORITY": {
      "TITLE": "Prioridade",
      "OPTIONS": {
        "NONE": "Nenhuma",
        "URGENT": "Urgente",
        "HIGH": "Elevada",
        "MEDIUM": "Média",
        "LOW": "Baixa"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Nenhuma",
        "INPUT_PLACEHOLDER": "Selecione a prioridade",
        "NO_RESULTS": "Nenhum resultado encontrado",
        "SUCCESSFUL": "Alterar a prioridade da conversa com o id {conversationId} para {priority}",
        "FAILED": "Não foi possível alterar a prioridade, por favor, tente novamente."
      }
    },
    "DELETE_CONVERSATION": {
      "TITLE": "Apagar conversa #{conversationId}",
      "DESCRIPTION": "Tem a certeza de que quer apagar esta conversa?",
      "CONFIRM": "Excluir"
    },
    "CARD_CONTEXT_MENU": {
      "PENDING": "Marcar como pendente",
      "RESOLVED": "Marcar como resolvida",
      "MARK_AS_UNREAD": "Marcar como não lida",
      "MARK_AS_READ": "Marcar como lida",
      "REOPEN": "Reabrir conversa",
      "SNOOZE": {
        "TITLE": "Adiar",
        "NEXT_REPLY": "Até à próxima resposta",
        "TOMORROW": "Até amanhã",
        "NEXT_WEEK": "Até à próxima semana"
      },
      "ASSIGN_AGENT": "Atribuir agente",
      "ASSIGN_LABEL": "Atribuir etiqueta",
      "AGENTS_LOADING": "A carregar agentes...",
      "ASSIGN_TEAM": "Atribuir equipa",
      "DELETE": "Apagar conversa",
      "OPEN_IN_NEW_TAB": "Open in new tab",
      "COPY_LINK": "Copy conversation link",
      "COPY_LINK_SUCCESS": "Conversation link copied to clipboard",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Conversa com ID {conversationId} atribuída a \"{agentName}\"",
          "FAILED": "Não foi possível atribuir agente. Por favor, tente novamente."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Não foi possível atribuir etiqueta. Por favor, tente novamente."
        },
        "LABEL_REMOVAL": {
          "SUCCESFUL": "Removed label #{labelName} from conversation id {conversationId}",
          "FAILED": "Couldn't remove label. Please try again."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Equipa \"{team}\" atribuída  a conversa de ID {conversationId}",
          "FAILED": "Não foi possível atribuir equipa. Por favor, tente novamente."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Assinatura da mensagem",
      "ENABLE_SIGN_TOOLTIP": "Ativar assinatura",
      "DISABLE_SIGN_TOOLTIP": "Desativar assinatura",
      "MSG_INPUT": "Shift + Enter para nova linha. Comece com '/' para selecionar uma resposta pronta.",
      "PRIVATE_MSG_INPUT": "Shift + Enter para nova linha. Esta mensagem apenas será visível para agentes",
      "MESSAGING_RESTRICTED": "You cannot reply to this conversation",
      "MESSAGING_RESTRICTED_WHATSAPP": "You can only reply using a template message due to 24-hour message window restriction",
      "MESSAGING_RESTRICTED_API": "You can only reply using a template message due to message window restriction",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "A assinatura da mensagem não está configurada. Por favor, configure-a nas configurações do perfil.",
      "COPILOT_MSG_INPUT": "Dê comandos adicionais ao copiloto ou pergunte qualquer outra coisa... Pressione enter para enviar o acompanhamento",
      "CLICK_HERE": "Clique aqui para atualizar",
      "WHATSAPP_TEMPLATES": "Template do WhatsApp"
    },
    "REPLYBOX": {
      "REPLY": "Responder",
      "PRIVATE_NOTE": "Nota Privada",
      "SEND": "Enviar",
      "CREATE": "Adicionar nota",
      "INSERT_READ_MORE": "Ler mais",
      "DISMISS_REPLY": "Descartar resposta",
      "REPLYING_TO": "Em resposta a:",
      "TIP_EMOJI_ICON": "Mostrar selecionador de emojis",
      "TIP_ATTACH_ICON": "Anexar ficheiros",
      "TIP_AUDIORECORDER_ICON": "Gravar áudio",
      "TIP_AUDIORECORDER_PERMISSION": "Permitir acesso ao áudio",
      "TIP_AUDIORECORDER_ERROR": "Não foi possível abrir o áudio",
      "AUDIO_CONVERSION_FAILED": "Audio conversion failed. Please try again.",
      "DRAG_DROP": "Arrastar e soltar aqui para anexar",
      "IMAGE_UPLOAD_SUCCESS": "Imagem carregada com sucesso",
      "START_AUDIO_RECORDING": "Iniciar gravação de áudio",
      "STOP_AUDIO_RECORDING": "Parar gravação de áudio",
      "COPILOT_THINKING": "Copiloto está pensando",
      "EMAIL_HEAD": {
        "TO": "PARA",
        "ADD_BCC": "Adicionar Bcc",
        "CC": {
          "LABEL": "Cc",
          "PLACEHOLDER": "E-mails separados por vírgulas",
          "ERROR": "Por favor, insira endereços de e-mail válidos"
        },
        "BCC": {
          "LABEL": "Bcc",
          "PLACEHOLDER": "E-mails separados por vírgulas",
          "ERROR": "Por favor, insira endereços de e-mail válidos"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Variáveis indefinidas",
        "MESSAGE": "Tem {undefinedVariablesCount} variáveis indefinidas na sua mensagem: {undefinedVariables}. Pretende enviar a mensagem mesmo assim?",
        "CONFIRM": {
          "YES": "Enviar",
          "CANCEL": "Cancelar"
        }
      },
      "QUOTED_REPLY": {
        "ENABLE_TOOLTIP": "Include quoted email thread",
        "DISABLE_TOOLTIP": "Don't include quoted email thread",
        "REMOVE_PREVIEW": "Remove quoted email thread",
        "COLLAPSE": "Collapse preview",
        "EXPAND": "Expand preview"
      }
    },
    "VISIBLE_TO_AGENTS": "Nota Privada: Apenas visível para si e para a sua equipa",
    "CHANGE_STATUS": "Estado da conversa alterado",
    "CHANGE_STATUS_FAILED": "A mudança de estado da conversa falhou",
    "CHANGE_AGENT": "Responsável da conversa alterado",
    "CHANGE_AGENT_FAILED": "Falha na alteração da atribuição",
    "ASSIGN_LABEL_SUCCESFUL": "Etiqueta atribuída com sucesso",
    "ASSIGN_LABEL_FAILED": "Falha na atribuição de etiqueta",
    "CHANGE_TEAM": "Equipa da conversa alterada",
    "SUCCESS_DELETE_CONVERSATION": "Conversa apagada",
    "FAIL_DELETE_CONVERSATION": "Não foi possível apagar a conversa! Tente novamente",
    "FILE_SIZE_LIMIT": "O ficheiro excede o tamanho limite para anexos de {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB",
    "FILE_TYPE_NOT_SUPPORTED": "This {fileName} file type is not supported in this conversation",
    "MESSAGE_ERROR": "Não foi possível enviar esta mensagem, por favor, tente novamente mais tarde",
    "SENT_BY": "Enviado por:",
    "BOT": "Bot",
    "NATIVE_APP": "Native app",
    "NATIVE_APP_ADVISORY": "This message was sent from the native app. Reply from Chatwoot to maintain the message window.",
    "SEND_FAILED": "Não foi possível enviar a mensagem! Tente novamente",
    "TRY_AGAIN": "Tentar novamente",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Escolher agente",
      "REMOVE": "Excluir",
      "ASSIGN": "Atribuir"
    },
    "CONTEXT_MENU": {
      "COPY": "Copiar",
      "REPLY_TO": "Responder a esta mensagem",
      "DELETE": "Excluir",
      "CREATE_A_CANNED_RESPONSE": "Adicionar às respostas prontas",
      "TRANSLATE": "Traduzir",
      "COPY_PERMALINK": "Copiar link para a mensagem",
      "LINK_COPIED": "URL da mensagem copiado para a área de transferência",
      "DELETE_CONFIRMATION": {
        "TITLE": "Tem a certeza que pretende apagar esta mensagem?",
        "MESSAGE": "Esta ação é irreversível",
        "DELETE": "Excluir",
        "CANCEL": "Cancelar"
      },
      "REPORT_MESSAGE": {
        "LABEL": "Report message",
        "TITLE": "Report Captain message",
        "DESCRIPTION": "Found an issue with this AI response? Let us know what went wrong and our team will review it to help improve Captain's accuracy.",
        "PROBLEM_TYPE": "Problem type",
        "PROBLEM_TYPE_PLACEHOLDER": "Select a problem type",
        "DESCRIPTION_LABEL": "Descrição",
        "DESCRIPTION_PLACEHOLDER": "Describe the problem in detail",
        "SUBMIT": "Report",
        "SUCCESS": "Thanks for reporting. Our team will take a look.",
        "ERROR": "Could not report this message. Please try again.",
        "REASONS": {
          "incorrect_information": "Incorrect information",
          "inappropriate_response": "Inappropriate response",
          "incomplete_response": "Incomplete response",
          "outdated_information": "Outdated information",
          "other": "Other"
        }
      }
    },
    "SIDEBAR": {
      "CONTACT": "Contacto",
      "COPILOT": "Copilot"
    },
    "VOICE_WIDGET": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NOT_ANSWERED_YET": "Not answered yet",
      "HANDLED_IN_ANOTHER_TAB": "Being handled in another tab",
      "REJECT_CALL": "Reject",
      "DISMISS_CALL": "Descartar",
      "JOIN_CALL": "Join call",
      "END_CALL": "End call",
      "MUTE": "Mute mic",
      "UNMUTE": "Unmute mic",
      "VIEW_CHAT_HISTORY": "View chat history",
      "GO_TO_CONVERSATION": "Go to conversation thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Enviar transcrição da conversa",
    "DESC": "Envia uma cópia da transcrição da conversa para o endereço de e-mail especificado",
    "SUBMIT": "Submeter",
    "CANCEL": "Cancelar",
    "SEND_EMAIL_SUCCESS": "A transcrição da conversa foi enviada com sucesso",
    "SEND_EMAIL_ERROR": "Ocorreu um erro, por favor, tente novamente",
    "SEND_EMAIL_PAYMENT_REQUIRED": "Email transcript is not available on your current plan. Please upgrade to use this feature.",
    "FORM": {
      "SEND_TO_CONTACT": "Enviar a transcrição ao cliente",
      "SEND_TO_AGENT": "Enviar a transcrição para o agente atribuído",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Enviar a transcrição para outro endereço de e-mail",
      "EMAIL": {
        "PLACEHOLDER": "Insira um endereço de e-mail",
        "ERROR": "Por favor, insira um endereço de e-mail válido"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Olá 👋. Bem-vindo ao {installationName}!",
    "DESCRIPTION": "Obrigado por se registar. Queremos que aproveite ao máximo o sistema {installationName}. Aqui estão algumas coisas que pode fazer no {installationName} para tornar a sua experiência ainda mais agradável.",
    "GREETING_MORNING": "👋 Bom dia, {name}. Bem-vindo ao {installationName}.",
    "GREETING_AFTERNOON": "👋 Boa tarde, {name}. Bem-vindo ao {installationName}.",
    "GREETING_EVENING": "👋 Boa noite, {name}. Bem-vindo ao {installationName}.",
    "READ_LATEST_UPDATES": "Ler as últimas atualizações",
    "ALL_CONVERSATION": {
      "TITLE": "Todas as suas conversas num único lugar",
      "DESCRIPTION": "Ver todas as conversas dos seus clientes num único painel. Pode filtrar as conversas pelo canal de entrada, etiquetas e estado.",
      "NEW_LINK": "Clique aqui para criar uma caixa de entrada"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Convidar os membros da sua equipa",
      "DESCRIPTION": "Já que se prepara para começar a conversar com o seu cliente, convide também os seus colegas para o ajudar. Pode adicionar colegas de equipa acrescentando os seus endereços de e-mail à lista de agentes.",
      "NEW_LINK": "Clique aqui para convidar um membro para a equipa"
    },
    "LABELS": {
      "TITLE": "Organizar conversas com etiquetas",
      "DESCRIPTION": "As etiquetas permitem-lhe categorizar facilmente as suas conversas. Crie etiquetas como #suporte, #faturacao, etc., para que as possa utilizar, mais tarde, numa conversa.",
      "NEW_LINK": "Clique aqui para criar etiquetas"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Criar respostas prontas",
      "DESCRIPTION": "Os modelos de resposta rápida pré-escritos ajudam-no a responder rapidamente a uma conversa. Os agentes podem inserir o caractere '/' seguido do código curto para inserir uma resposta.",
      "NEW_LINK": "Clique aqui para criar uma resposta pronta"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Agente atribuído",
    "SELF_ASSIGN": "Atribuir a mim",
    "TEAM_LABEL": "Equipa atribuída",
    "SELECT": {
      "PLACEHOLDER": "Nenhuma"
    },
    "ACCORDION": {
      "CONTACT_DETAILS": "Detalhes do contacto",
      "CONVERSATION_ACTIONS": "Ações de conversa",
      "CONVERSATION_LABELS": "Etiquetas da conversa",
      "CONVERSATION_INFO": "Informação da conversa",
      "CONTACT_NOTES": "Notas do contacto",
      "CONTACT_ATTRIBUTES": "Atributos do contacto",
      "PREVIOUS_CONVERSATION": "Conversas anteriores",
      "MACROS": "Macros",
      "LINEAR_ISSUES": "Casos Linear Associados",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "SHARED_FILES": "Attachments"
    },
    "SHARED_FILES": {
      "EMPTY": "No attachments yet",
      "DOWNLOAD": "Download file",
      "DOWNLOAD_ERROR": "Could not download the file. Please try again.",
      "MEDIA_HEADING": "Media",
      "FILES_HEADING": "Files",
      "VIEW_ALL": "Visualizar todos",
      "SHOW_LESS": "Show less",
      "MORE_COUNT": "+{count}",
      "UNTITLED_FILE": "Untitled file",
      "JUMP_TO_MESSAGE": "Jump to message"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Pendente",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Criar atributo",
    "NO_RECORDS_FOUND": "Nenhum atributo encontrado",
    "UPDATE": {
      "SUCCESS": "Atributo atualizado com sucesso",
      "ERROR": "Não foi possível atualizar o atributo. Por favor, tente mais tarde"
    },
    "ADD": {
      "TITLE": "Adicionar",
      "SUCCESS": "Atributo adicionado com sucesso",
      "ERROR": "Não foi possível adicionar o atributo. Por favor, tente mais tarde"
    },
    "DELETE": {
      "SUCCESS": "Atributo apagado com sucesso",
      "ERROR": "Não foi possível apagar o atributo. Por favor, tente mais tarde"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Adicionar atributos",
      "PLACEHOLDER": "Pesquisar atributos",
      "NO_RESULT": "Nenhum atributo encontrado"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "De",
    "TO": "Para",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Assunto",
    "EXPAND": "Expand email"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "A participar",
    "SIDEBAR_TITLE": "Participantes da conversa",
    "NO_RECORDS_FOUND": "Nenhum resultado encontrado",
    "ADD_PARTICIPANTS": "Selecionar participantes",
    "REMANING_PARTICIPANTS_TEXT": "+{count} outros",
    "REMANING_PARTICIPANT_TEXT": "+{count} outro",
    "TOTAL_PARTICIPANTS_TEXT": "{count} pessoas estão a participar.",
    "TOTAL_PARTICIPANT_TEXT": "{count} pessoa está a participar.",
    "NO_PARTICIPANTS_TEXT": "Ninguém está a participar!",
    "WATCH_CONVERSATION": "Junte-se à conversa",
    "YOU_ARE_WATCHING": "Está a participar",
    "API": {
      "ERROR_MESSAGE": "Não foi possível atualizar, por favor, tente novamente!",
      "SUCCESS_MESSAGE": "Participantes atualizados!"
    }
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Ver conteúdo traduzido",
    "DESC": "Pode visualizar o conteúdo traduzido em cada linguagem.",
    "ORIGINAL_CONTENT": "Conteúdo original",
    "TRANSLATED_CONTENT": "Conteúdo traduzido",
    "NO_TRANSLATIONS_AVAILABLE": "Nenhuma tradução está disponível para este conteúdo"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  }
}
